import 'perform-base/js/base';
import 'perform-base/js/globals';
import 'perform-base/js/actions';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

import accountDetails from './account-details.js';
import addExpense from './add-expense.js';
import addPayment from './add-payment.js';
import addWorkLog from './add-worklog.js';
import accountEdit from './account-edit.js';
import contractView from './contracts/view.js';
import contractWrite from './contracts/write.js';
import createInvoice from './create-invoice';
import editProjectWorkTypes from './edit-project-work-types';
import createProject from './create-project.js';
import accounts from './leads.js';
import notes from './notes.js';
import {copyLoginUrl} from './user';
import subscriptionDates from './subscriptions/dates.js';
import subscriptionDelete from './subscriptions/delete.js';
import {taskView} from './tasks.js';
import {projectView, projectPermissions} from './projects.js';
import {postView} from './posts.js';
import kanban from './kanban.js';
import workLogs from './worklogs.js';

window.Brain = {
  accountDetails,
  accountEdit,
  addExpense,
  addPayment,
  addWorkLog,
  copyLoginUrl,
  contractView,
  contractWrite,
  createInvoice,
  editProjectWorkTypes,
  createProject,
  accounts,
  kanban,
  notes,
  postView,
  projectView,
  projectPermissions,
  subscriptionDates,
  subscriptionDelete,
  taskView,
  workLogs,
};

$('form').find('.select2').select2();



// WEBPACK FOOTER //
// ./assets/js/app.js